import React, { Component } from 'react';

import { Parse } from 'parse';

import { List, ListItem } from 'material-ui/List';
import Delete from 'material-ui/svg-icons/action/delete';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';

class CalendarAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      calendarId: null,
    };
  }

  handleCalendarIdChange = (e) => {
    this.setState({calendarId: e.target.value});
  }
  
  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.props.onCancel} />,
      <FlatButton
        label="Add"
        primary={true}
        onClick={() => this.props.onAdd(this.state.calendarId)} />,
    ];

    return (

      <Dialog
        title="Add Calendar"
        open={this.props.open}
        actions={actions}
        contentStyle={{width: '360px'}}>

        <TextField
          floatingLabelText="Calendar ID"
          hint="www.google.com"
          onChange={this.handleCalendarIdChange} />

      </Dialog>

    );
  }
}

class CalendarPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      calendars: props.calendars,
      isCalendarAddOpen: false,
    };
  }

  componentWillReceiveProps(props) {
    this.setState({calendars: props.calendars});
  }

  handleCalendarAdd = (calendarId) => {
    const that = this;

    var CalendarInfo = Parse.Object.extend("CalendarInfo");
    var calendarInfo = new CalendarInfo();

    calendarInfo.set("calendarId", calendarId);
    calendarInfo.set("service", "google");

    calendarInfo.save(null, {
      success: function(calendarInfo) {
        console.log("Saved calendar info.")
        that.props.onCalendarAdd(calendarInfo);
      },
      error: function(calendarInfo, err) {
        console.log("Error saving calendar info: " + err);
      }
    });

    this.setState({isCalendarAddOpen: false});
  };

  handleCalendarDelete = (calendar) => {
    const that = this;
    calendar.destroy({
      success: function(calendarInfo) {
        that.props.onCalendarDelete(calendarInfo);
      },
      error: function(err) {
        console.log("Error deleting calendar info " + err);
      }
    });
  }

  render() {
    const actions = [
      <FlatButton
        label="Add Calendar"
        primary={true}
        onClick={() => this.setState({isCalendarAddOpen: true})} />,
      <FlatButton
        label="Done"
        primary={true}
        onClick={this.props.onClose} />,
    ];

    return (
      <Dialog
        title="Calendars"
        actions={actions}
        open={true}
        onRequestClose={this.props.onClose}
        autoScrollBodyContent={true}>

        <div>
          <List>
            {this.state.calendars.map((calendar) => 
              <ListItem
                key={calendar.id}
                primaryText={calendar.get('calendarId')}
                rightIconButton={(
                  <IconButton onClick={() => this.handleCalendarDelete(calendar)}>
                      <Delete />
                  </IconButton> 
                )}
              />    
            )}
          </List>

        </div>

        <CalendarAdd 
          open={this.state.isCalendarAddOpen} 
          onCancel={() => this.setState({isCalendarAddOpen: false})}
          onAdd={this.handleCalendarAdd} />

      </Dialog>
    );
  }

}

export default CalendarPicker;


// WEBPACK FOOTER //
// ./src/scenes/Planner/components/CalendarPicker.js